import { render, staticRenderFns } from "./sidebarLeft.vue?vue&type=template&id=631188bb&"
import script from "./sidebarLeft.vue?vue&type=script&lang=ts&"
export * from "./sidebarLeft.vue?vue&type=script&lang=ts&"
import style0 from "./sidebarLeft.vue?vue&type=style&index=0&id=631188bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports